import { createFromIconfontCN } from "@ant-design/icons";

const IconUrl = [
  // '//at.alicdn.com/t/a/font_4910844_tkll6o5uahe.js', // A2A
  "//at.alicdn.com/t/a/font_4922077_2jy7cew7mhe.js", // A2A-base
  "//at.alicdn.com/t/a/font_4922078_qfwsch5d33d.js", // A2A-web
  "//at.alicdn.com/t/a/font_4553737_efim7lxqyqi.js", // 扩展图标
  "//at.alicdn.com/t/a/font_4515024_aboh27uaw7t.js", // 通义基础
  "//at.alicdn.com/t/a/font_4807885_6wjcpzayws6.js", // 百炼
];

// 检测版本冲突并解决，'_iconfont_svg_string_' + projectId
// !process.env.PLUGIN && versionConflictCheck('_iconfont_svg_string_4515024');
// !process.env.PLUGIN && versionConflictCheck('_iconfont_svg_string_4553737');

// export const TYIcon = !process.env.PLUGIN ? TYIconBase : TYIconPlugin;
export const TYIcon = createFromIconfontCN({ scriptUrl: IconUrl });
